var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstalogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.33333 0.519287C3.73167 0.519287 0 4.25095 0 8.85262V22.186C0 26.7876 3.73167 30.5193 8.33333 30.5193H21.6667C26.2683 30.5193 30 26.7876 30 22.186V8.85262C30 4.25095 26.2683 0.519287 21.6667 0.519287H8.33333ZM25 3.85262C25.92 3.85262 26.6667 4.59929 26.6667 5.51929C26.6667 6.43929 25.92 7.18595 25 7.18595C24.08 7.18595 23.3333 6.43929 23.3333 5.51929C23.3333 4.59929 24.08 3.85262 25 3.85262ZM15 7.18595C19.6017 7.18595 23.3333 10.9176 23.3333 15.5193C23.3333 20.121 19.6017 23.8526 15 23.8526C10.3983 23.8526 6.66667 20.121 6.66667 15.5193C6.66667 10.9176 10.3983 7.18595 15 7.18595ZM15 10.5193C13.6739 10.5193 12.4021 11.0461 11.4645 11.9838C10.5268 12.9214 10 14.1932 10 15.5193C10 16.8454 10.5268 18.1171 11.4645 19.0548C12.4021 19.9925 13.6739 20.5193 15 20.5193C16.3261 20.5193 17.5979 19.9925 18.5355 19.0548C19.4732 18.1171 20 16.8454 20 15.5193C20 14.1932 19.4732 12.9214 18.5355 11.9838C17.5979 11.0461 16.3261 10.5193 15 10.5193Z",
    fill: "#7E81F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstalogo);
export default __webpack_public_path__ + "static/media/instalogo.bf82dbcee8599aa1d520bab21d4e7efa.svg";
export { ForwardRef as ReactComponent };